import { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Container,
  Card,
  Spinner,
  Badge,
} from "react-bootstrap";
import { FaHistory } from "react-icons/fa";
import moment from "moment";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";

const ExpenditureViewModel = ({
  show,
  handleClose,
  ependitureId,
  ependiture,
}) => {
  const [expenditureData, setExpenditureData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (!show || !ependitureId) return;

    const fetchExpenditureData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${BASE_URL}/api/expenses-logs/${ependitureId}/`,
          { headers: HEADERS },
        );

        setExpenditureData(response.data);
      } catch (err) {
        console.error("Error fetching expenditure data:", err);
        setError("Failed to load expenditure details.");
      } finally {
        setLoading(false);
      }
    };

    fetchExpenditureData();
  }, [show, ependitureId]);
  const getBadgeColor = (status) => {
    switch (status) {
      case "Paid":
        return "#ffc107";
      case "Approved":
        return "#28a745";
      case "Submitted":
        return "#6c757d";
      case "Rejected":
        return "#dc3545";
      default:
        return "#343a40";
    }
  };
  const renderChanges = (changes) => {
    if (!changes || typeof changes !== "object") return "—";

    const validChanges = Object.entries(changes).filter(
      ([, v]) => v?.new !== null && v?.new !== "" && v?.new !== undefined,
    );

    if (validChanges.length === 0) return "—";

    return (
      <ul className="mb-0 ps-3">
        {validChanges.map(([field, value], idx) => (
          <li key={idx}>
            <strong>{field}</strong>:{" "}
            <span className="text-muted">{value.previous ?? "—"}</span> →{" "}
            <span className="text-success">{value.new}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      scrollable
      dialogClassName="custom-modern-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100 d-flex justify-content-between align-items-center">
          <span className="fw-semibold">
            💰 {ependiture?.expense_type || "Expense Details"}
          </span>

          <span
            className="badge"
            style={{
              backgroundColor: getBadgeColor(ependiture?.status),
              padding: "6px 12px",
              color: "#fff",
            }}
          >
            {ependiture?.status}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading expenditure data...</p>
          </div>
        ) : error ? (
          <p className="text-danger text-center">{error}</p>
        ) : (
          <Container fluid>
            <Card className="mb-3 shadow-sm">
              <Card.Body className="small">
                <Row>
                  {/* LEFT COLUMN */}
                  <Col md={6}>
                    {ependiture?.created_at && (
                      <p className="mb-1">
                        <strong>Created At:</strong>{" "}
                        {moment(ependiture.created_at).format("DD-MM-YYYY")}
                      </p>
                    )}

                    {ependiture?.created_by && (
                      <p className="mb-1">
                        <strong>Created By:</strong> {ependiture.created_by}
                      </p>
                    )}

                    {ependiture?.expense_type && (
                      <p className="mb-1">
                        <strong>Expense Type:</strong> {ependiture.expense_type}
                      </p>
                    )}

                    {ependiture?.ticket?.id && (
                      <p className="mb-1">
                        <strong>Ticket ID:</strong> {ependiture.ticket.id}
                      </p>
                    )}

                    {ependiture?.technician?.first_name && (
                      <p className="mb-1">
                        <strong>Technician:</strong>{" "}
                        {ependiture.technician.first_name}
                      </p>
                    )}

                    {ependiture?.amount && (
                      <p className="mb-1">
                        <strong>Amount:</strong> ₹ {ependiture.amount}
                      </p>
                    )}

                    {ependiture?.approvedAmount && (
                      <p className="mb-1">
                        <strong>Approved Amount:</strong> ₹{" "}
                        {ependiture.approvedAmount}
                      </p>
                    )}
                  </Col>

                  {/* RIGHT COLUMN */}
                  <Col md={6}>
                    {ependiture?.status && (
                      <p className="mb-1">
                        <strong>Status:</strong> {ependiture.status}
                      </p>
                    )}

                    {ependiture?.expense_date && (
                      <p className="mb-1">
                        <strong>Expense Date:</strong> {ependiture.expense_date}
                      </p>
                    )}

                    {ependiture?.from_field && (
                      <p className="mb-1">
                        <strong>From:</strong> {ependiture.from_field}
                      </p>
                    )}

                    {ependiture?.to && (
                      <p className="mb-1">
                        <strong>To:</strong> {ependiture.to}
                      </p>
                    )}

                    {ependiture?.description && (
                      <p className="mb-1">
                        <strong>Description:</strong> {ependiture.description}
                      </p>
                    )}

                    {ependiture?.approvedRemark && (
                      <p className="mb-1">
                        <strong>Approved Remark:</strong>{" "}
                        {ependiture.approvedRemark}
                      </p>
                    )}

                    {ependiture?.paidRemark && (
                      <p className="mb-1">
                        <strong>Paid Remark:</strong> {ependiture.paidRemark}
                      </p>
                    )}

                    {ependiture?.rejectedRemark && (
                      <p className="mb-1">
                        <strong>Rejected Remark:</strong>{" "}
                        {ependiture.rejectedRemark}
                      </p>
                    )}

                    {ependiture?.image && (
                      <div className="mt-2">
                        <strong>Attachment:</strong>
                        <br />
                        <img
                          src={ependiture.image}
                          alt="expense"
                          className="img-fluid rounded"
                          style={{ maxHeight: "150px" }}
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="shadow-sm">
              <Card.Body>
                <h5 className="text-primary mb-3">
                  <FaHistory className="me-2" />
                  Expense Activity Log
                </h5>

                {expenditureData?.logs?.length > 0 ? (
                  <div style={{ overflowX: "auto" }}>
                    <table className="inventory-table w-100">
                      <thead>
                        <tr>
                          <th style={{ minWidth: "150px" }}>Updated By</th>
                          <th style={{ minWidth: "170px" }}>Date & Time</th>
                          <th style={{ minWidth: "120px" }}>Action</th>
                          <th style={{ minWidth: "250px" }}>Changes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {expenditureData.logs.map((log, idx) => (
                          <tr key={idx}>
                            <td>{log.updated_by || "—"}</td>
                            <td>{log.updated_on || "—"}</td>
                            <td>
                              <Badge bg="secondary">{log.action}</Badge>
                            </td>
                            <td>{renderChanges(log.changes)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted text-center mb-0">
                    No expense activity available.
                  </p>
                )}
              </Card.Body>
            </Card>
          </Container>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExpenditureViewModel;
